import { Mesh } from "@babylonjs/core/Meshes/mesh";
// import { MeshBuilder } from "@babylonjs/core/meshBuilder";

export default class Wall {

    constructor(scene) {

        this.mesh = createMesh();

        function createMesh() {
            const mesh = Mesh.CreateBox("Mur", 1, scene);

            return mesh
        }
    }
}